'use strict';

var React = require('react');

var SvgMaximizeMajor = function SvgMaximizeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9 5a1 1 0 1 0 0 2h2.586l-3.293 3.293a1 1 0 1 0 1.414 1.414l3.293-3.293v2.586a1 1 0 1 0 2 0v-5c0-.025 0-.05-.003-.075a1 1 0 0 0-.997-.925h-5zm-8 9.5a1.5 1.5 0 0 1 1.5-1.5h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3a1.5 1.5 0 0 1-1.5-1.5v-3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1a1.5 1.5 0 0 0-1.5 1.5v8.5h2v-8h14v14h-8v2h8.5a1.5 1.5 0 0 0 1.5-1.5v-15a1.5 1.5 0 0 0-1.5-1.5h-15z"
  }));
};

exports.SvgMaximizeMajor = SvgMaximizeMajor;
